import { Skeleton } from './Skeleton';

export default function ProductCardSkeleton() {
  return (
    <div className="ui-overflow-hidden ui-rounded-md ui-border ui-border-solid ui-border-gray-300">
      <div className="ui-justify-between ui-overflow-hidden ui-rounded ui-bg-white">
        <Skeleton className="ui-mb-4 ui-flex ui-h-[290px] ui-items-center ui-justify-center ui-rounded ui-bg-gray-300" />
        <div className="ui-flex ui-h-full ui-flex-col">
          <div className="ui-flex ui-flex-1 ui-flex-col">
            <div className={'ui-space-y-2 ui-p-4 ui-pb-6'}>
              <div className="ui-flex ui-flex-wrap ui-items-center ui-justify-between ui-gap-1 ui-text-sm ui-font-semibold ui-text-gray-700">
                <div className="ui-h-2.5 ui-w-[40%] ui-rounded-full ui-bg-gray-200" />

                <div className="ui-h-2.5 ui-w-[40%] ui-rounded-full ui-bg-gray-200" />
                <div className="ui-mt-5 ui-flex ui-h-auto ui-w-full ui-flex-col">
                  <div className="ui-mb-1 ui-h-2.5 ui-w-[35%] ui-rounded-full ui-bg-gray-200" />
                  <div className="ui-mt-1 ui-h-2.5 ui-w-[60%] ui-rounded-full ui-bg-gray-200" />
                </div>
              </div>

              <div className="ui-flex ui-h-auto ui-w-full">
                <div className="ui-mt-3 ui-h-9 ui-w-28 ui-rounded-md ui-border ui-bg-gray-200 ui-px-3" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
